// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }


// 授权网点列表
export function getOfflineList(data) {
  return request({
    url: "/api/sale_auth/get_offline_list",
    method: "post",
    data,
  });
}




